import { render, staticRenderFns } from "./PdfFormViewer.vue?vue&type=template&id=3d5faf02&scoped=true&"
import script from "./PdfFormViewer.vue?vue&type=script&lang=js&"
export * from "./PdfFormViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfFormViewer.vue?vue&type=style&index=0&id=3d5faf02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5faf02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5faf02')) {
      api.createRecord('3d5faf02', component.options)
    } else {
      api.reload('3d5faf02', component.options)
    }
    module.hot.accept("./PdfFormViewer.vue?vue&type=template&id=3d5faf02&scoped=true&", function () {
      api.rerender('3d5faf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/formBuilder/components/PdfFormViewer.vue"
export default component.exports